import { Button, ButtonLoaderPlacement, ButtonSize } from '@farmasiet/frontendcore-reactcomponents';
import * as React from 'react';

import { getTranslation, keys } from '../../../../../Resources/Translations';
import { EmailInput } from '../../../../Email/Check/EmailInput';
import { Modal, ModalHeading, ModalText } from '../../../../ReactComponents/Modal/Modal';

interface ProductAvailabilityNotificationsInputModalProps {
    checkEmailUrl: string;
    setEmail: (email: string) => void;
    setErrorMessage: (error: string) => void;
    setIsButtonDisabled: (value: boolean) => void;
    errorMessage: string;
    handleSubmit: () => void;
    isRequestActive: boolean;
    isButtonDisabled: boolean;
    isVisible: boolean;
    setIsVisible: (value: boolean) => void;
}

export const ProductAvailabilityNotificationsInputModal = (props: ProductAvailabilityNotificationsInputModalProps) => {
    const handleClose = () => {
        props.setIsVisible(false);
        props.setErrorMessage('');
        props.setIsButtonDisabled(false);
    };

    return (
        <Modal open={props.isVisible} onClose={handleClose} id="ProductAvailabilityNotificationInputModal">
            <ModalHeading>{getTranslation(keys['product.availabilityNotification.modalHeading'])}</ModalHeading>
            <ModalText>{getTranslation(keys['product.availabilityNotification.modalSubheading'])}</ModalText>

            <div className="ProductAvailabilityNotificationModal__InputWrapper">
                <EmailInput
                    checkEmailUrl={props.checkEmailUrl}
                    onEmailChange={(email) => props.setEmail(email)}
                    onInput={() => props.setErrorMessage('')}
                    setLoadingStatus={(value) => props.setIsButtonDisabled(value)}
                    errorMessage={props.errorMessage}
                    showEmailSuggestionMessage
                />

                <Button
                    size={ButtonSize.Medium}
                    loading={props.isRequestActive}
                    onClick={props.handleSubmit}
                    disabled={props.isButtonDisabled}
                    className="ProductAvailabilityNotificationModal__Button"
                    loaderPlacement={ButtonLoaderPlacement.Right}
                >
                    {getTranslation(keys['product.availabilityNotification.modalButton'])}
                </Button>
            </div>

            <span className="ProductAvailabilityNotification__PrivacyPolicy">
                {getTranslation(keys['product.availabilityNotification.privacyPolicyText'])}
                &nbsp;
                <a href="/om-farmasiet.no/sikkerhet-og-personvern">{getTranslation(keys['product.availabilityNotification.privacyPolicyLink'])}</a>.
            </span>
        </Modal>
    );
};
